(function() {
  define('tlhServicesDate',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesDate', []).factory('TlhDateService', [
      '$filter', function($filter) {
        var factory;
        factory = {};
        factory.getDateLabel = function(startDate, endDate) {
          var dateLabel, endsOnDateOrdinal, eventDateOrdinal;
          dateLabel = null;
          eventDateOrdinal = factory.getOrdinal(startDate);
          endsOnDateOrdinal = factory.getOrdinal(endDate);
          if (startDate) {
            startDate = new Date(startDate);
            if (endDate && endDate.toString() !== startDate.toString()) {
              endDate = new Date(endDate);
              if (startDate.getYear() === endDate.getYear()) {
                if (startDate.getMonth() === endDate.getMonth()) {
                  dateLabel = 'Du ' + factory.formatDate(startDate, "d" + eventDateOrdinal) + ' au ' + factory.formatDate(endDate, "d" + endsOnDateOrdinal + " MMMM yyyy");
                } else {
                  dateLabel = 'Du ' + factory.formatDate(startDate, "d" + eventDateOrdinal + " MMMM") + ' au ' + factory.formatDate(endDate, "d" + endsOnDateOrdinal + " MMMM yyyy");
                }
              } else {
                dateLabel = 'Du ' + factory.formatDate(startDate, "d" + eventDateOrdinal + " MMMM yyyy") + ' au ' + factory.formatDate(endDate, "d" + endsOnDateOrdinal + " MMMM yyyy");
              }
            } else {
              dateLabel = factory.formatDate(startDate, "d" + eventDateOrdinal + " MMMM yyyy");
            }
          }
          return dateLabel;
        };
        factory.formatDate = function(date, format) {
          return $filter('date')(date, format);
        };
        factory.getOrdinal = function(date) {
          if (date && new Date(date).getDate() === 1) {
            return 'er';
          } else {
            return '';
          }
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=date.js.map
;
